import { ReactNode, Suspense, useEffect } from 'react';
import Navbar from '../pages/home/components/Navbar';
import Footer from '../pages/home/components/Footer';

interface LayoutProps {
  children: ReactNode;
}

// Loading spinner matching teal theme
function LoadingSpinner() {
  return (
    <div className="min-h-screen bg-[#0A0F0A] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-2 border-[#00E599]/20"></div>
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#00E599] animate-spin"></div>
        </div>
        <p className="text-[#E0EEEE]/60 text-sm">Loading...</p>
      </div>
    </div>
  );
}

export default function Layout({ children }: LayoutProps) {
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Suspense fallback={<LoadingSpinner />}>
          {children}
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
